import store from '@/store'
import Vue from 'vue';

Vue.use({
  install(Vue) {
    Vue.prototype.$loading = {

      start() {
        store.commit('app/setAppLoading', true)

      },

      finish() {
        store.commit('app/setAppLoading', false)
      }
    }
  }
})

export default (_) => { }